import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export interface ApiErrorResponse {
  error: {
    code: string;
    message?: string;
  };
}

export function getErrorMessageCode(
  error: unknown,
  fallbackCode = 'common.error_occurred',
): string {
  if (
    error instanceof HttpErrorResponse &&
    error.error &&
    typeof error.error === 'object' &&
    'error' in error.error &&
    typeof error.error.error === 'string'
  ) {
    return error.error.error;
  }
  return fallbackCode;
}

export function handleApiError(
  error: unknown,
  fallbackCode = 'unknown',
): Observable<never> {
  return throwError(() => getErrorMessageCode(error, fallbackCode));
}

/**
 * Returns the translation key for an error code returned by the backend.
 * Codes that already contain a dot are treated as fully-qualified i18n keys
 * (e.g. `common.invalid_email`) and used as-is. Bare snake_case codes
 * (e.g. `password_already_set`) are scoped under the given flow prefix.
 */
export function toTranslationKey(code: string, flowPrefix: string): string {
  return code.includes('.') ? code : `${flowPrefix}.${code}`;
}
